import { configureStore } from "@reduxjs/toolkit";
import { analyticsReducer as analytics } from '../features/analytics';
import { schoolReducer as school } from '../features/school';
import { reducer } from '../redux';

export const store = configureStore({
  reducer: {
    root: reducer,
    analytics,
    school,
  },
});
